var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"myFont",attrs:{"id":"app"}},[_c('v-main',[_c('router-view'),_c('go-top',{attrs:{"size":50,"bg-color":"#212121"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }